export const calcWeightedScore = (score: number | null, weight: number): number | null => {
	if (score === null) return null;
	return score * (weight / 100);
};

export const calcWeightedDiff = (
	score: number | null,
	initialScore: number | null | undefined,
	weight: number
): number | null => {
	if (score === null || initialScore === null || initialScore === undefined) return null;
	return (score - initialScore) * (weight / 100);
};

export const formatWeightedValue = (value: number | null): string => {
	if (value === null) return "—";
	return value % 1 === 0 ? String(value) : value.toFixed(1);
};

export const formatDiff = (diff: number | null, threshold = 0.05): string | null => {
	if (diff === null || Math.abs(diff) < threshold) return null;
	const formatted = diff % 1 === 0 ? String(Math.abs(diff)) : Math.abs(diff).toFixed(1);
	return diff > 0 ? `+${formatted}` : `-${formatted}`;
};
